import { FormControl, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { ISelectInputOption } from './ResidentsTableHeaderMultiSelectInput';

interface ResidentsTableHeaderSelectInputProps {
  selectedOption: string;
  availableOptions: ISelectInputOption[];
  onChange: (event: SelectChangeEvent<string>) => void;
}
const ResidentsTableHeaderSelectInput = (props: ResidentsTableHeaderSelectInputProps) => {
  return (
    <FormControl>
      <Select
        displayEmpty
        value={props.selectedOption}
        onChange={props.onChange}
        renderValue={(selected) => {
          const selectedOption = props.availableOptions.find((option) => option.value === selected);
          return selectedOption ? selectedOption.label : 'Select Option'; // Fallback in case selected option isn't found
        }}
        inputProps={{ 'aria-label': 'Without label' }}
        style={{ borderRadius: '24px', height: '42px', width:'250px' }}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: '24px',
            },
          },
        }}
      >
        {props.availableOptions.map((availOption) => (
          <MenuItem key={availOption.value} value={availOption.value}>
            <ListItemText primary={availOption.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ResidentsTableHeaderSelectInput;
